import React, { Component } from 'react';

import { scrollTo } from '@utils/scroll';

export default class ScrollToTopOnMount extends Component {
  componentDidMount() {
    scrollTo({ left: 0, top: 0 });
  }

  render() {
    return null;
  }
}
